import { Address } from '../types/case';

export const formatAddress = (address?: Address, includePostCode = false) => {
  if (!address) {
    return '-';
  }

  const parts = [
    address.addressLine1,
    address.addressLine2,
    address.addressLine3,
    address.addressLine4,
    address.addressLine5
  ];

  if (includePostCode) {
    parts.push(address.postcode);
  }

  return Object.values(parts).filter(Boolean).join(', ');
};

export const removeSpaceStartEnd = (string: string) => string.replace(/^\s+|\s+$/g, '');

export const formatedPostcode = (string: string) => {
  const stringValue = removeSpaceStartEnd(string);
  return stringValue.replace(/^(.*)(\d)/, '$1 $2').toUpperCase();
};

export const checkSpaceBetweenWords = (string: string) => {
  const stringValue = removeSpaceStartEnd(string);
  return /\s/g.test(stringValue);
};
